import { Rat, ShieldCheck, Search, Leaf } from 'lucide-react';
import SpiracleLogo from '../../img/spiracle_logo.png';
import CTA from '../Cta';

function GasStoveRepairService() {
    return (
        <div className="chimney-repair-container">
            <section className="chimney-repair-hero">
                <div className="chimney-repair-hero-content">
                    <h1 className="chimney-repair-title">Rodent Control Services</h1>
                    <p className="chimney-repair-subtitle">
                        Rodents cause damage to food, property and spread diseases. Our Integrated Pest Management (IPM) approach is especially important in rodent control and delivers complete results.
                    </p>
                    <p className="chimney-repair-subtitle">
                        We integrate rodent inspection, sanitation, rodent proofing (exclusion), population reduction, trapping and use of rodenticides as needed.
                    </p>
                    <p className="chimney-repair-subtitle">
                        An absolutely new and highly effective treatment used in all developing countries, designed keeping human safety in mind.
                    </p>
                    <p className="chimney-repair-subtitle">
                        We adopt a treatment regimen depending on the type of premise or outlet - for instance, granules cannot be used where food items are stored such as kitchens.
                    </p>

                    <button className="chimney-repair-cta-btn"
                        onClick={() => (window.location.href = "tel:8530352444")}
                        style={{ cursor: "pointer" }}>
                        Get a Free Inspection
                    </button>
                </div>
            </section>

            <div className="chimney-repair-service-img">
                <img src={SpiracleLogo} alt="Rodent Control" />
            </div>

            <section className="chimney-repair-why-choose">
                <div className="chimney-repair-why-content">
                    <h2 className="chimney-repair-heading">Why Choose Our Rodent Control?</h2>
                    <div className="chimney-repair-why-grid">
                        <div className="chimney-repair-why-item">
                            <Search size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Rodent Inspection</h3>
                            <p className="chimney-repair-description">
                                Complete inspection to locate rodent activity, entry points and nesting areas.
                            </p>
                        </div>
                        <div className="chimney-repair-why-item">
                            <ShieldCheck size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Rodent Proofing</h3>
                            <p className="chimney-repair-description">
                                Exclusion and proofing to stop rodents from entering your property.
                            </p>
                        </div>
                        <div className="chimney-repair-why-item">
                            <Rat size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Population Reduction</h3>
                            <p className="chimney-repair-description">
                                Glue traps, snap traps and safe rodenticides to reduce the population.
                            </p>
                        </div>
                        <div className="chimney-repair-why-item">
                            <Leaf size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Human Safety First</h3>
                            <p className="chimney-repair-description">
                                Designed keeping human safety in mind with premise-based treatment plans.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="chimney-repair-process">
                <h2 className="chimney-repair-heading">Our Rodent Control Process</h2>
                <div className="chimney-repair-process-steps">
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 1: Inspection</h3>
                        <p className="chimney-repair-step-description">
                            Identifying rodent signs - droppings, gnaw marks, footprints and runways.
                        </p>
                    </div>
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 2: Sanitation</h3>
                        <p className="chimney-repair-step-description">
                            Guidance on sanitation to remove food sources and shelter for rodents.
                        </p>
                    </div>
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 3: Trapping & Baiting</h3>
                        <p className="chimney-repair-step-description">
                            Placement of glue traps, snap traps and rodenticides as per the premise type.
                        </p>
                    </div>
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 4: Proofing</h3>
                        <p className="chimney-repair-step-description">
                            Sealing of entry points for long term exclusion of rodents from the property.
                        </p>
                    </div>
                </div>
            </section>

            <CTA />
        </div>
    );
}

export default GasStoveRepairService;